import { apiGet, apiPost } from "app/Services/ApiService";
import moment from "moment";

export var Utils = {
    roundToTwo: (number) => (Math.round((number + Number.EPSILON) * 100) / 100).toFixed(2),
    formatCurrency: (number) => {
        var currency = 
            new Intl.NumberFormat('en-US', {
                style: 'currency',
                currencySign: 'accounting',
                currency: 'USD'
            }).format(number)

        return currency;
    },
    downloadFile:
     (url, fileName, successAction, errorAction, finallyAction, isPost, postBody) => {
        let func = () => apiGet(url, { responseType: "blob" });

        if (isPost) {
            func = () => apiPost(url, postBody, { responseType: "blob" });
        }

        func().then(response => {
                const contentDisposition = response.headers['content-disposition'];

                if (contentDisposition) {
                    let fileNameRegex = new RegExp(/file[Nn]ame=("?.+"?);/);
                    const fileNameMatch = fileNameRegex.exec(contentDisposition);
                    
                    if (fileNameMatch && fileNameMatch.length === 2) {
                        fileName = fileNameMatch[1].replaceAll("\"", "");
                    }
                }

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();

                console.log("File downloading successfully");

                if (successAction) {
                    successAction(response);
                }
            }).catch(
                (response) => {
                    console.log(response);
                    if (errorAction) {
                        errorAction(response);
                    }
          }
        ).finally(() => {
            if (finallyAction) {
                finallyAction();
            }
        });
    },
    groupByArrays: (xs, key) => {
        return xs.reduce((rv, x) => {
            let v = key instanceof Function ? key(x) : x[key];
            let el = rv.find((r) => r && r.key === v);
            if (el) {
                el.values.push(x);
            }
            else {
                rv.push({ key: v, values: [x] });
            }

            return rv;
        }, []);
    },
    emptyGuid: () => "00000000-0000-0000-0000-000000000000",
    isGuid: (guidString) =>  {
        var pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        var regEx = new RegExp(pattern);

        return pattern.test(guidString) === true;
    },
    isValidEmailAddress: (emailAddress) => {
        let emailAddressFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

        return emailAddress.match(emailAddressFormat);
    },
    convertToDatePicker : (date) => {
        let newDate = moment(date);
        if (date == null || date === undefined || newDate.year() <= 1900) {
            return "YYYY-MM-DD";
        }
        return newDate.format("YYYY-MM-DD");
    },
    convertToDatePickerDefaultToday : (date) => {
        let newDate = moment(date);
        if (date == null || date === undefined || newDate.year() <= 1900) {
            return moment().format("YYYY-MM-DD");
        }
        return newDate.format("YYYY-MM-DD");
    },
    formatDate : (date, nullAsNA, format) => {
        if (!format) {
            format = "MM/DD/YYYY";
        }

        if (date) {
            if (moment(date).year() <= 1901) {
                return nullAsNA ? "N/A" : null;
            }

            return moment(date).format(format);
        }

        return nullAsNA ? "N/A" : null;
    },
    formatDateTime : (date, nullAsNA) => {
        return Utils.formatDate(date, nullAsNA, "MM/DD/YYYY h:mm:ss A");
    },
    onlyUnique: (value, index, self) => {
        return self.indexOf(value) === index;
    },
    isMinDate: (value) => {
        return new Date(value).toLocaleDateString() == new Date("0001-01-01T00:00:00").toLocaleDateString();
    },
    hwStatementReport: (content) => {
        return `<style>
    @media print {
      .statement { page-break-before: always; } /* page-break-after works, as well */
    }
    table{
    /* max-width: 650px; */
    width: 550px;
    /* margin: 0 auto; */
    border: 2px solid silver !important;
    }
    th {
    padding: 0px 10px;
    border-right: 1px solid silver;
    }
    
    td {
    padding: 0px 10px;
    border-right: 1px solid silver;
    text-align:right;
    }
    td:nth-child(1) {  
    text-align:left;
    }
    .main{
    width:550px;
    margin-left:auto;
    margin-right:auto;
    }
    .logo{
    text-align:right
    }
    .pdf-right {
        text-align:right;
    }
    .pfd-left {
        text-align:left;
    }
    
    </style>
    <link rel=\"stylesheet\" href=\"https://admin.fringesecure.com/Content/bootstrap.css\">
<link rel=\"stylesheet\" href=\"https://admin.fringesecure.com/Content/Custom/HWStatement.css\">
    <div class="main">
    <div class="PDFHeader" >
                          <div class="logo">
                              <img src="data:image/png;base64,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" />
                          </div>
                          <div>
                              <p style="padding-top:20px;font-size:16px!important;max-width:550px">
                                  This personal benefits statement is a brief outline of your benefits and how your Health &amp; Welfare (H&amp;W) funds were
                                  allocated for the month. Please review the information carefully and direct any questions to feedback portal.
                              </p>
                          </div>
          </div>
          ${content}
          </div>`;
    },
    isEmployer: (userInfo, includeSysAdmin) => {
        var roles = userInfo?.roles ?? [];

        return roles.some(r => r === "EMPLOYER") || (includeSysAdmin && roles.some(r => r === "ADMIN-SYS-ADMIN" || r === "ADMIN-SYS-MANAGER"));
    },
    isBroker: (userInfo, includeSysAdmin) => {
        var roles = userInfo?.roles ?? [];

        return roles.some(r => r === "BROKER") || (includeSysAdmin && roles.some(r => r === "ADMIN-SYS-ADMIN" || r === "ADMIN-SYS-MANAGER"));
    },
    escapeRegExp: (string) => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    isUUID: (string) => {
        const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
        return regexExp.test(string);
    },
    today : () => {
        return moment().format("MM/DD/YYYY");
    },
}
